import React, { useEffect, useState } from "react";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import { Col, Row } from "react-bootstrap";
import { Button, Checkbox, createTheme, FormControlLabel, MuiThemeProvider, TextField } from "@material-ui/core";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useHistory, useParams } from "react-router-dom";
import { deleteTherapeuticGroup, getTherapeuticGroupById, postTherapeuticGroup, updateTherapeuticGroup } from "../../../../api/therapeuticGroup";
import { useSkeleton } from "../../../hooks/useSkeleton";
import MyAutocomplete from "../../../components/MyAutocomplete";
import { getCenters } from "../../../../api/center";
import { getTherapists } from "../../../../api/therapist";
import { getUsers } from "../../../../api/user";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: '#F64E60'
    }
  }
})

function getEmptyTherapeuticGroup() {
    return {
        active: true
    }
}

export default function EditTherapeuticGroupPage() {
    const therapeuticGroupId = useParams().id
    const history = useHistory();
    const [therapeuticGroup, setTherapeuticGroup] = useState(getEmptyTherapeuticGroup());
    const [centers, setCenters] = useState([]);
    const [therapists, setTherapists] = useState([]);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(0);
    const [refresh, setRefresh] = useState(null);
    
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()
    
    useEffect(() => {
        setRefresh(false);
    }, [refresh])
    
    useEffect(() => {
        fetch();
    }, [])

    function fetch() {

        getCenters()
            .then((res) => {
                setCenters(res.data);
            })
            .catch((error) => {
                alertError({ error, customMessage: "No se han podido encontrar centros." });
            })

        getUsers({ therapists: true, active: true })
            .then((res) => {
                setTherapists(res.data);
            })
            .catch((error) => {
                alertError({ error, customMessage: "No se han podido encontrar terapeutas." });
            })

        if (!therapeuticGroupId) { disableLoadingData(); return;}
        getTherapeuticGroupById(therapeuticGroupId)
            .then((res) => {
                const therapeuticGroup = res.data;
                setTherapeuticGroup(therapeuticGroup);
                console.log(therapeuticGroup)
                disableLoadingData();
            })
            .catch((error) => {
                alertError({

                    error,
                    customMessage: "No se ha encontrado el grupo terapéutico."
                })
            })
    }

    function saveTherapeuticGroup() {
        if (!therapeuticGroup?._id) {
            postTherapeuticGroup(therapeuticGroup)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Grupo creado correctamente."});
                    history.push("/therapeutic-groups");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "No se ha podido crear el grupo."});
                })
            }
            else {
                updateTherapeuticGroup(therapeuticGroup._id, therapeuticGroup)
                .then((res) => {
                    alertSuccess({ title: "Éxito!", customMessage: "Grupo terapéutico actualizado correctamente."});
                    history.push("/therapeutic-groups");
                })
                .catch((error) => {
                    alertError({ error, customMessage: "No se ha podido actualizar el grupo"});
                })
        }
    }

    const handleChangeBlock = (element, number, selected) => (event) => {
        const actBlock = therapeuticGroup[`block${number}`];
        const value = event?.target?.value || selected;
        setTherapeuticGroup({ ...therapeuticGroup, [`block${number}`]: { ...actBlock, [element]: value } });
    }

    const Block = (number) => {

        return (
            <>
                <Row>
                    {/* <Col>
                        <TextField
                            label={`Name block ${number}`}
                            value={therapeuticGroup[`block${number}`]?.name}
                            onChange={handleChangeBlock("name", number)}
                            margin="normal"
                            variant="outlined"
                            required
                        />
                    </Col> */}
                    { !refresh && therapists.length > 0 && (
                        <Col>
                            <MyAutocomplete 
                                options={ therapists }
                                getOptionLabel={(option) => option.fullName}
                                value={therapeuticGroup[`block${number}`]?.therapist}
                                onChange={(event, selected) => {
                                    handleChangeBlock("therapist", number, selected)(null);
                                    setRefresh(true)
                                }}
                                placeholder={`Selecciona el terapeuta del bloque ${number}`}
                                label={`Terapeuta bloque ${number}`}
                            />
                        </Col>
                    )}
                    {/* <Col>
                        <TextField
                            label={`Address block ${number}`}
                            value={therapeuticGroup[`block${number}`]?.address}
                            onChange={handleChangeBlock("address", number)}
                            margin="normal"
                            variant="outlined"
                            required
                        />
                    </Col> */}
                </Row>
            </>
        )
    }

    const Blocks = () => {
        const numbers = [1, 2, 3];

        return (
            <>
            <br />
                <h4>Bloques</h4>
                { numbers.map((num) => {
                    return (
                        <>
                           {Block(num)} 
                        </>
                    )
                })}
            </>
        )
    }

    const handleChange = (element) => (event) => {
        setTherapeuticGroup({ ...therapeuticGroup, [element]: event.target.value });
    }

    if (isLoadingData) 
        return (<ContentSkeleton />)
    return (
        <>
            <Card>
                <CardHeader title="Editar Grupo Terapéutico" />
                <CardBody>
                    <Row>
                        <Col>
                            <TextField
                                label="Nombre"
                                value={therapeuticGroup?.fullName}
                                onChange={handleChange("fullName")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                        </Col>
                    </Row>
                    <Row>
                        { !refresh && (
                            <Col>
                                <MyAutocomplete 
                                    options={ centers }
                                    getOptionLabel={(option) => option.fullName}
                                    value={therapeuticGroup?.center}
                                    onChange={(event, selected) => {
                                        setTherapeuticGroup({ ...therapeuticGroup, center: selected})
                                    }}
                                    placeholder="Selecciona el centro"
                                    label={"Centro"}
                                />
                            </Col>
                        )}
                    </Row>

                    {Blocks()}

                    <Row>
                        <Col>
                            <FormControlLabel
                                control={<Checkbox checked={therapeuticGroup?.active} onChange={() => setTherapeuticGroup({ ...therapeuticGroup, active: !therapeuticGroup?.active })} name="checkActive" />}
                                label="Activo"
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/therapeutic-groups')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Atrás
            </Button>
            <Button
                onClick={() => saveTherapeuticGroup()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Guardar grupo terapéutico
            </Button>
            {therapeuticGroup?._id && <>
                <MuiThemeProvider theme={theme}>
                <Button
                    onClick={() => setOpenConfirmDialog(true)}
                    variant="outlined"
                    color="secondary">
                    Eliminar grupo terapéutico
                </Button>
                </MuiThemeProvider>

                <ConfirmDialog
                title={'Seguro que quieres eliminar este grupo terapéutico?'}
                open={openConfirmDialog}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteTherapeuticGroup(therapeuticGroup._id)
                        .then((res) => {
                            alertSuccess({ title: "Éxito!", customMessage: "TherapeuticGroup eliminado correctamente." });
                            history.push("/therapeutic-groups");
                        })
                        .catch((error) => {
                            alertError({ error, customMessage: "No se ha podido eliminar el therapeuticGroup." });
                        })
                }}
                />
      </>}
        </>
    )
}